<template>
  <a class="chapter" href="#story" v-smooth-scroll>
    <img :src="require(`@/assets/images/scene-bg.png`)" class="chapter-bg"/>
    <div class="chapter-title">
      <p class="title">{{storyName}}</p>
      <h1>{{title}}</h1>
      <span>▼ 點擊繼續</span>
    </div>
  </a>
</template>

<script>
export default {
  name: 'stage-banner',
  props: {
    storyName: {
      type: String,
      required: false,
      default: '怪盜懶雲'
    },
    title: {
      type: String,
      required: true,
    },
  }
}
</script>

<style scoped>

.chapter{
  cursor: pointer;
  display: block;
  position: relative;
  background-color: var(--chapter-title-bg);
  height: 100vh;
  /* margin-bottom: var(--gradient-height); */
}

.chapter:hover, .chapter:focus{
  text-decoration: none;
}

.chapter::before{
  position: absolute;
  width: 100%;
  height: var(--gradient-height);
  bottom: 0;
  left: 0;
  background: linear-gradient(180deg, var(--chapter-title-bg), transparent);
  content: '';
  transform: translate(0, 100%);
}

.chapter .chapter-bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  opacity: .1;
}

.chapter .chapter-title{
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.chapter .chapter-title h1{
  margin: 0;
  color: #fff;
  margin-bottom: 2rem;
}

.chapter .chapter-title .title{
  margin: 0;
  color: #fff;
  font-size: 3rem;
  font-weight: 1000;
}

.chapter .chapter-title .title:not(:last-child){
  margin-bottom: 2rem;
}

.chapter span, .chapter a{
  color: #fff;
  letter-spacing: .5rem;
  font-size: 1.4em;
  text-shadow: 0px 0px 10px #fff;
  animation-name: shining;
  animation-direction: alternate;
  animation-duration: .8s;
  animation-fill-mode: both;
  animation-iteration-count: infinite;
}

.chapter a:hover, .chapter a:focus{
  text-decoration: none;
  color: #fff;
}

@keyframes shining {
  0% {
    opacity: .2;
  }

  100%{
    opacity: 1;
  }
}

@media (min-width: 768px){
  .chapter::before{
    background: linear-gradient(180deg, var(--chapter-title-bg), transparent);
  }

  .chapter-selection ul li{
    flex: 0 0 100%;
  }

}
</style>
